import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangePasswordComponent } from './change-password.component';
import { CoreModule } from 'app/core/core.module';

@NgModule({
  imports: [
    CoreModule,
    CommonModule
  ],
  declarations: [ChangePasswordComponent],
  entryComponents: [ChangePasswordComponent]
})
export class ChangePasswordModule { }
